import * as Yup from "yup";
import { CAMPAIGN_AGENT_NAME_REQUIRED, CAMPAIGN_COMPANY_NAME_REQUIRED, CAMPAIGN_DIRECTION_REQUIRED, CAMPAIGN_END_DATE_MIN, CAMPAIGN_END_DATE_REQUIRED, CAMPAIGN_NAME_CHAR_MESSAGE, CAMPAIGN_NAME_MAX_CHAR, CAMPAIGN_NAME_MIN_CHAR, CAMPAIGN_NAME_REQUIRED, CAMPAIGN_START_DATE_INVALID, CAMPAIGN_START_DATE_REQUIRED, CAMPAIGN_TRACKERS_REQUIRED, CAMPAIGN_TYPE_REQUIRED } from "../../helpers/validation.messages";

export const AddCampaignSchema = Yup.object({
    companyName: Yup.string().required(CAMPAIGN_COMPANY_NAME_REQUIRED).trim(),
    campaignName: Yup.string().required(CAMPAIGN_NAME_REQUIRED).trim()
        .min(CAMPAIGN_NAME_MIN_CHAR, CAMPAIGN_NAME_CHAR_MESSAGE)
        .max(CAMPAIGN_NAME_MAX_CHAR, CAMPAIGN_NAME_CHAR_MESSAGE),
    type: Yup.string().required(CAMPAIGN_TYPE_REQUIRED).trim(),
    direction: Yup.string().required(CAMPAIGN_DIRECTION_REQUIRED).trim(),
    startDate: Yup.date().required(CAMPAIGN_START_DATE_REQUIRED).typeError(CAMPAIGN_START_DATE_INVALID),
    endDate: Yup.date().required(CAMPAIGN_END_DATE_REQUIRED).min(Yup.ref('startDate'), CAMPAIGN_END_DATE_MIN).typeError(CAMPAIGN_END_DATE_MIN),
});

export const AddCampaignTrackerSchema = Yup.object({
    trackers: Yup.array().min(1, CAMPAIGN_TRACKERS_REQUIRED).required(CAMPAIGN_TRACKERS_REQUIRED)
});

export const EditCampaignSchema = Yup.object({
    campaignName: Yup.string().required(CAMPAIGN_NAME_REQUIRED).trim(),
    type: Yup.string().required(CAMPAIGN_TYPE_REQUIRED).trim(),
    direction: Yup.string().required(CAMPAIGN_DIRECTION_REQUIRED).trim(),
    startDate: Yup.date().required(CAMPAIGN_START_DATE_REQUIRED).typeError(CAMPAIGN_START_DATE_INVALID),
    endDate: Yup.date().required(CAMPAIGN_END_DATE_REQUIRED).min(Yup.ref('startDate'), CAMPAIGN_END_DATE_MIN).typeError(CAMPAIGN_END_DATE_MIN),
});

export const AgentNameSchema = Yup.object({
    name: Yup.string().required(CAMPAIGN_AGENT_NAME_REQUIRED).trim(),
});